import { AllowancePeriodCard } from "@/components/allowance-period/AllowancePeriodCard";
import { PtoBalanceSection } from "@/components/pto-balance/PtoBalanceSection";

export function DashboardPage() {
  return (
    <div className="space-y-6">
      <PtoBalanceSection />
      <AllowancePeriodCard />
    </div>
  );
}
